// extracted by mini-css-extract-plugin
export default {"image":"SigninImage_image__ZQKqt"};